import { initializeApp } from "firebase/app";
import { getFirestore } from "@firebase/firestore";
import { getStorage } from "@firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyD8iTM6glB7brsO3pKpDswsc6mylZXchVQ",
  authDomain: "appyard-e37d6.firebaseapp.com",
  projectId: "appyard-e37d6",
  storageBucket: "appyard-e37d6.appspot.com",
  messagingSenderId: "653528283492",
  appId: "1:653528283492:web:8c87e304072322afafa271"
};

const app = initializeApp(firebaseConfig);
export const firestore = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);